<div class="snackbar-wrapper">
  <!-- Gambar di kiri -->
  @if (data.image) {
    <img [src]="data.image" alt="notification image" class="notif-image" />
  }

  <!-- Konten di kanan -->
  <div class="notif-content">
    <h3 class="notif-title">{{ data.title }}</h3>
    <p class="notif-body">{{ data.body }}</p>

    @if (data.actions?.length > 0) {
      <div class="notif-actions">
        @for (act of data.actions; track act) {
          <button mat-button (click)="onAction(act.action,act.url,act.key)">
            {{ act.label }}
          </button>
        }
      </div>
    }
  </div>
</div>